import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loader } from '../common';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  redirectTo = '/auth' 
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Si l'authentification est en cours de chargement, on affiche un loader
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader size="large" color="primary" text="Chargement..." />
      </div>
    );
  }

  // Si l'utilisateur n'est pas authentifié, on le redirige
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Si l'utilisateur est authentifié, on affiche les enfants
  return <>{children}</>;
};
